module.exports = __webpack_public_path__ + "static/media/car.bf2f3cb7.svg";